<div
  class="doc-viewer-container secondary-shadow"
  [class]="isFilePreview ? 'doc-viewer-preview' : ''"
>
  @if (isLoading) {
  <div
    class="flex flex-column align-item-center justify-content-center h-full w-full"
  >
    <app-doc-loader [fileType]="fileType"></app-doc-loader>
  </div>
  }@else {
    @if (fileType == 'doc') {
      <app-eml-view [data]="data" [emlHtml]="viewData" [viewer]="'div'" [emlHeight]="isFilePreview ? 'calc(100vh - var(--topNav-height) - 15.67rem)':'calc(100vh - var(--topNav-height) - 4.5rem)'"></app-eml-view>
      }@if (fileType == 'pdf') {
      <app-eml-view
        style="display: block; height: 100%"
        [emlHtml]="viewData"
        [viewer]="'pdf'"
        [data]="data"
      ></app-eml-view>
      }@else if (fileType == 'image') {
        <p-image
        class="doc-viewer-image"
        [src]="viewData"
        alt="Image"
        preview="true" />
      }
 }
</div>
